import { AxiosInstance } from "axios"
import { Admin } from "../../users/userTypes"

export enum MerchantQuery {
    ADMINS_FOR_MERCHANT = "admins-for-merchant",
    SATELLITES_LIST = "satellites-for-merchant",
    BILL_RECEIVERS_LIST = "bill-receivers-for-merchant",
}

export type FetchMerchantAdminsResponse = Readonly<{
    administrators: Admin[]
}>

export type FetchMerchantSatellitesResponse = Readonly<{
    satellites: { id: number; name: string; isActive: boolean }[]
}>

export type FetchMerchantBillReceiversResponse = Readonly<{
    billReceivers: { id: number; uid: string; displayName: string; isActive: boolean }[]
}>

type FetchMerchantAdminParams = Readonly<{
    merchantId: number
    isActive?: boolean
}>

export async function fetchMerchantAdmins(
    { merchantId, isActive }: FetchMerchantAdminParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMerchantAdminsResponse> {
    const url = `/merchants/${merchantId}/administrators`

    const { data } = await axios.get(url, { params: { isActive }, signal })

    return data
}

export async function fetchMerchantSatellites(
    { merchantId }: FetchMerchantAdminParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMerchantSatellitesResponse> {
    const url = `/merchants/${merchantId}/satellites`

    const response = await axios.get(url, { signal })

    return response.data
}

export async function fetchMerchantBillReceivers(
    { merchantId }: FetchMerchantAdminParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchMerchantBillReceiversResponse> {
    const url = `/merchants/${merchantId}/billReceivers`
    const response = await axios.get(url, { signal })

    return response.data
}
